import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'src/components/ui';
import Markdown from 'react-markdown';
import { useHistory } from 'react-router';

import NotificationsApi from '../api/NotificationsApi';

import PopupDesktopNotificationUWEEntity from './PopupDesktopNotificationUWEEntity';
import { PopupNotification } from '../context/DesktopNotificationPopupContext';

function PopupDesktopNotification({
  notification,
  onClose
}: {
  notification: PopupNotification
  onClose: (notification: PopupNotification) => void
}) {
  const { id, subject, message, cleared, link, notificationType, uweEntity, workflow: workflowInfo } = notification;

  const { id: uweEntityId, isOpen: uweEntityIsOpen } = uweEntity || {};

  const { slug } = workflowInfo || {};

  const history = useHistory();

  // Mark as read immediately
  useEffect(() => {
    if (!cleared) {
      NotificationsApi.markAsRead({ id });
    }
  }, []);

  // Determine whether notification should open, never open if not
  const shouldOpen = useMemo(() => notificationType !== 'Workflow' || uweEntityIsOpen, [notification]);

  const [isOpen, setIsOpen] = useState(shouldOpen);

  // On close otherwise, wait for regular modal close animation, then remove from queue
  // Also handles closing if isOpen was never true
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        onClose?.(notification);
      }, 200);
    }
  }, [isOpen]);

  const onSubmit = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Modal key={id} isOpen={isOpen} size="xl" backdrop="static">
      <ModalHeader className="modal-header-notification">{subject}</ModalHeader>
      <ModalBody className="ql-viewer">
        {notificationType === 'Workflow' ? (
          uweEntityId && <PopupDesktopNotificationUWEEntity id={uweEntityId} workflowInfo={workflowInfo} slug={slug} onSubmit={onSubmit} />
        ) : (
          <Markdown>{message}</Markdown>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="col-lg-12">
          {notificationType !== 'Workflow' && (
            <Button className="float-left" color="primary" onClick={() => history.push(link)}>
              Acceder
            </Button>
          )}
          <Button className="float-right" color="primary" onClick={() => setIsOpen(false)}>
            Cerrar
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default PopupDesktopNotification;
